/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Absence } from '../models/Absence'
import type { AbsenceArray } from '../models/AbsenceArray'
import type { SubstituteArray } from '../models/SubstituteArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AbsencesService {
  /**
   * 👤 Get all absences that belong to the employee of the authenticated user
   * @returns any OK
   * @throws ApiError
   */
  public static getAbsences(): CancelablePromise<{
    data?: AbsenceArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/absences',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
  /**
   * 👤 Store an absence.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeAbsence(requestBody?: Absence): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/absences',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Deletes an absence.
   * @param absenceId
   * @returns any OK
   * @throws ApiError
   */
  public static deleteAbsence(absenceId: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/absences/{absenceId}',
      path: {
        absenceId: absenceId,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Updates an absence.
   * @param absenceId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static updateAbsence(
    absenceId: number,
    requestBody?: Absence,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/absences/{absenceId}',
      path: {
        absenceId: absenceId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Get the id and name of all possible Substitutes for a given time period
   * @param start
   * @param end
   * @returns any OK
   * @throws ApiError
   */
  public static possibleAbsenceSubstitutes(
    start: string,
    end: string,
  ): CancelablePromise<{
    data?: SubstituteArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/possibleAbsenceSubstitutes/{start}/{end}',
      path: {
        start: start,
        end: end,
      },
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
      },
    })
  }
}
